import styled, { keyframes } from "styled-components";

// Animação suave de entrada
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

export default function EmBreve() {
  return (
    <Container>
      <BackgroundGlow />
      <Content>
        <Logo src="/img/logo.png" alt="logo" />
        
        <Badge>Coming Soon</Badge>
        
        <Title>Em <span>Breve</span></Title>

        <Subtitle>
          Estamos preparando algo incrível para você!
        </Subtitle>

        <Description>
          Essa funcionalidade está sendo lapidada para entregar a melhor experiência. 
          Falta pouco para você explorar todas as novidades.
        </Description>

        <Button href="/">
          Voltar para a Home
        </Button>
      </Content>
    </Container>
  );
}

/* ESTILO */

const Container = styled.div`
  background-color: #080808;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  position: relative;
  overflow: hidden;
  font-family: 'Inter', -apple-system, sans-serif;
`;

// Círculo de luz ao fundo para dar profundidade
const BackgroundGlow = styled.div`
  position: absolute;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, rgba(255, 26, 26, 0.15) 0%, rgba(0, 0, 0, 0) 70%);
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
`;

const Content = styled.div`
  text-align: center;
  max-width: 800px;
  z-index: 1;
  animation: ${fadeIn} 0.8s ease-out;
  padding: 40px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.02);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

const Logo = styled.img`
  width: clamp(120px, 15vw, 180px);
  margin-bottom: 40px;
  filter: drop-shadow(0 0 10px rgba(255, 26, 26, 0.3));
`;

const Badge = styled.span`
  background: rgba(255, 26, 26, 0.1);
  color: #ff1a1a;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 700;
  border: 1px solid rgba(255, 26, 26, 0.2);
  display: inline-block;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  font-size: clamp(40px, 8vw, 80px);
  color: #fff;
  margin-bottom: 15px;
  font-weight: 800;
  letter-spacing: -2px;

  span {
    color: #ff1a1a;
    background: linear-gradient(135deg, #ff1a1a 0%, #ff5e5e 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Subtitle = styled.h2`
  font-size: clamp(18px, 4vw, 24px);
  color: #f0f0f0;
  margin-bottom: 20px;
  font-weight: 400;
  opacity: 0.9;
`;

const Description = styled.p`
  font-size: clamp(14px, 2vw, 18px);
  color: #888;
  margin-bottom: 40px;
  line-height: 1.6;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
`;

const Button = styled.a`
  display: inline-block;
  padding: 16px 40px;
  background: linear-gradient(135deg, #ff1a1a 0%, #cc0000 100%);
  color: #fff;
  border-radius: 12px;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 20px rgba(255, 26, 26, 0.2);

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 15px 30px rgba(255, 26, 26, 0.4);
    filter: brightness(1.1);
  }

  &:active {
    transform: translateY(-1px);
  }
`;